<ng-container>
    <div class="fill" [formGroup]="form">
        <table class="table" style="width: 100%">
            <tbody>
                <tr>
                    <td>
                        Allow the app to collect data to improve performance and
                        stability
                    </td>
                    <td>
                        <mat-slide-toggle
                            formControlName="allowSentry"
                        ></mat-slide-toggle>
                    </td>
                </tr>
                <tr>
                    <td>
                        Allow the app to collect data to improve the product
                    </td>
                    <td>
                        <mat-slide-toggle
                            formControlName="allowMixpanel"
                        ></mat-slide-toggle>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <p class="help-block">
        For more information visit
        <a href="https://flyfreely.io/data-collection-notice" target="_blank">
            https://flyfreely.io/data-collection-notice
        </a>
    </p>
</ng-container>
